import { Program21,Program22,Program23,Program24,Program25,Program26,Program31,Program32,Program33,Program34,Program35,Program36 } from "../../Assets";


export const third = [
    {
        topic:"Alog",
        img:Program31,
        data:"Any One Programming Language/ Framework",
        tech:"C, CPP, Java, JavaScript, Python, React, Node, Flutter",
        duration:"long duration"
    },
    {
        topic:"Alog",
        img:Program32,
        data:"Expertise In Data Structures",
        tech:"C or Java",
        duration:"long duration"

    },
    {
        topic:"Alog",
        img:Program33,
        data:"Expertise In Product Core",
        tech:"DSA, Algos, OS, DBMS, Networks, Web development, Devops",
        duration:"long duration"
    },   
    {
        topic:"Domain",
        img:Program34,
        data:"Expertise In Data Science",
        tech:"Python, Tableau, TensorFlow",
        duration:"Short duration"
    },
    {
        topic:"Domain",
        img:Program35,
        data:"Expertise In AI / ML",
        tech:"Python, Tableau, TensorFlow",
        duration:"long duration"
    },
    {
        topic:"Domain",
        img:Program36,
        data:"Expertise In Web Development",
        tech:"MERN/MEAN/ Spring Boot",
        duration:"long duration"
    },
]

export const second = [
    {
        img:Program21,
        data:"1:1 carrier guidance till your placements",
        color:"#F75151"
    },
    {
        img:Program22,
        data:"Building a professional Resume from scratch",
        color:"#F78351"
    },       
    {
        img:Program23,
        data:"Online Mentors for Roadmap guidance",
        color:"#F7518D"
    },       
    {
        img:Program24,
        data:"Help you to code and progress",
        color:"#F7C651"
    },
    {
        img:Program25,
        data:"Regular Updates on industrial skills",
        color:"#5193F7"
    },
    {
        img:Program26,
        data:"Mock interviews with experts",
        color:"#F75151"
    },

]